export default __webpack_public_path__ + "static/media/right gun.fff4dbfa.png";